<template>
    <div class="login-page">
        <div class="topbar">
            <div class="topbar-box">
                <div class="logo_icon" @click="go(3)"></div>
                <div class="topBar_tpxs" v-if="viewType==1&&showTop">
                    <span class="topBar_tpxs-item w212 underline">Yet to register your organisation?</span>
                    <span class="default_Btn w141" @click="$router.push('/registered')">Admin Sign Up</span>
                </div>
                <div class="topBar_tpxs" v-if="viewType==2&&showTop">
                    <span class="topBar_tpxs-item underline">Have an account?</span>
                    <span class="default_Btn w141" @click="$router.push('/login')">Admin Log In</span>
                </div>
            </div>
        </div>
        <slot name="mainCenter"></slot>
        <div class="footer_bar">
            <div class="footer_center">
                <!--<div class="footer_copy">© Copyright Beny 2020</div>-->
                <div class="footer_tpxs">
                    <span style="cursor: pointer;" @click="go(1)">Terms of use</span>
                    <span style="cursor: pointer;" class="topBar_tpxs-item" @click="go(2)">Privacy policy</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {   
    props:{
        viewType:{ // 1 login 2 register
            type:Number,
            default:()=>{
                return 1
            }
        },
        showTop:{ 
            type:Boolean,
            default:()=>{
                return true
            }
        },
    },
    data() {
        return {
        }
    },
    methods:{
        go(key){
            if(key===1){
                window.open('https://hello.beny.com.au/#/terms-conditions',"_target")
            }else if (key ===3){
                window.location.replace('https://www.beny.com.au')
            }else{
                window.open('https://hello.beny.com.au/#/privacy-policy',"_target")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.login-page{
    min-width: 1340px;
    background: #3A3835;
    min-height: 100vh;
    .topbar{
        background-color: #32312E;
        .topbar-box{
            width: 1220px;
            display: flex;
            align-items: center;
            height: 64px;
            margin: 0 auto;
            background-color: #32312E;
            .logo_icon{
                cursor: pointer;
                width: 65px;
                height: 31px;
                background: url('../../assets/logo.png') no-repeat;
                background-size: contain;
            }
            .topBar_tpxs{
                display: flex;
                align-items: center;
                margin-left: auto;
                justify-content: flex-end;
                .topBar_tpxs-item{
                    min-width: 145px;
                    margin-right: 30px;
                    width: 144px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #FFFFFF;
                    opacity: 1;
                }
                .w212{
                    min-width: 212px;
                }
                .w141{
                    width: 141px;
                }
                .underline{
                    text-decoration: underline;
                }
            }
        }
    }
    .main-page{
        height: calc(100vh - 128px);
    }
    .footer_bar{
        background-color: #32312E;
        .footer_center{
            width: 1220px;
            display: flex;
            align-items: center;
            height: 64px;
            margin: 0 auto;
            background-color: #32312E;
            .footer_copy{
                width: 142px;
                font-size: 15px;
                font-weight: 400;
                color: #FFFFFF;
                opacity: 1;
            }
            .footer_tpxs{
                margin-left: auto;
                .topBar_tpxs-item{
                    margin-left: 36px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/sign-view.vue